
import React, { useContext, useState, useEffect } from 'react';
import logoImage from '../Assets/prawnhublogowhite.png';
import { SoundContext } from '../Context/SoundContext';


const Header = ({ onHelpClick, onVibeClick, onWtfClick, activeNav }) => {
    const { isMuted, toggleMute, playSoundFx } = useContext(SoundContext);
    const [isMobile, setIsMobile] = useState(false);
    
    // Check if we're on mobile
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 480);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);
    
    // Always render: left = Help the Prawns, center = Just Vibe, right = Wtf is this?
    // Helper to play click SFX and call handler
    const handleClickWithSfx = (handler) => (e) => {
        if (playSoundFx) playSoundFx('click');
        if (handler) handler(e);
    };
    
    return (
    <header className="header header-fixed" role="banner" style={{ position: 'fixed', width: '100%', zIndex: 5, boxSizing: 'border-box', padding: '0 12px' }}>
            <img
                src={logoImage}
                alt="PrawnHub Logo - Return to Interactive Prawn Simulator Homepage"
                className="logo"
                style={{ cursor: 'pointer' }}
                onClick={handleClickWithSfx(() => { window.location.href = '/'; })}
                title="PrawnHub - Ultimate Interactive Prawn Experience"
            />
            <nav className="nav-links nav-links-centered" role="navigation" aria-label="Main navigation">
                <button
                    className={`nav-link nav-link-left${activeNav === 'kill' ? ' nav-link-active' : ' nav-link-inactive'}`}
                    onClick={handleClickWithSfx(onHelpClick)}
                    style={{ cursor: 'pointer', background: 'none', border: 'none', color: 'inherit', font: 'inherit' }}
                    aria-label="Access Help the Prawns simulator mode"
                    title="Help the Prawns - Interactive Prawn Rescue Simulator"
                >
                   Help the Prawns
                </button>
                <button
                    className={`nav-link nav-link-center${activeNav === 'vibe' ? ' nav-link-active' : ' nav-link-inactive'}`}
                    onClick={handleClickWithSfx(onVibeClick)}
                    style={{ cursor: 'pointer', background: 'none', border: 'none', color: 'inherit', font: 'inherit' }}
                    aria-label="Access Just Vibe prawn simulator mode"
                    title="Just Vibe - Peaceful Prawn Watching Experience"
                >
                    Just Vibe
                </button>
                <button 
                    className="nav-link nav-link-inactive" 
                    onClick={handleClickWithSfx(onWtfClick)} 
                    style={{ cursor: 'pointer', background: 'none', border: 'none', color: 'inherit', font: 'inherit' }}
                    aria-label="Learn about PrawnHub satirical art experience"
                    title="What is PrawnHub? - Learn About Our Art Installation"
                >
                    {isMobile ? 'WTF?' : 'Wtf is this?'}
                </button>
            </nav>
            <button
                className={`nav-link mute-button-header mute-nav-link ${isMuted ? 'muted' : 'unmuted'}`}
                onClick={handleClickWithSfx(toggleMute)}
                style={{
                    position: 'absolute',
                    right: isMobile ? 8 : 24,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    padding: isMobile ? '6px 10px' : '10px 20px',
                    borderRadius: '6px',
                    border: 'none',
                    fontWeight: 'bold',
                    backgroundColor: isMuted ? '#2596be' : '#d8ecf3',
                    color: isMuted ? 'black' : 'black',
                    cursor: 'pointer',
                    transition: 'background 0.2s',
                    fontSize: isMobile ? '0.85em' : '1em',
                }}
                aria-label={`${isMuted ? 'Unmute' : 'Mute'} PrawnHub audio experience`}
                title={`${isMuted ? 'Unmute' : 'Mute'} underwater sounds and prawn simulator audio`}
            >
                {isMuted ? 'Unmute' : 'Mute'}
            </button>
        </header>
    );
};

export default Header;